import collectionTabTemplate from './collectionTabTemplate';

export default collectionTabTemplate(['collections'], ({ datasets }) => datasets.read);
